import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-password-policy',
  templateUrl: './password-policy.component.html',
  styleUrls: ['./password-policy.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PasswordPolicyComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<PasswordPolicyComponent>) {}

  ngOnInit(): void {
  }
  close() {
    this.dialogRef.close();
  }
}
